var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagesSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80961 7.91667H10.1429M6.80961 10.8333H12.6429M10.1429 17.5C14.2851 17.5 17.6429 14.1421 17.6429 10C17.6429 5.85786 14.2851 2.5 10.1429 2.5C6.00081 2.5 2.64294 5.85786 2.64294 10C2.64294 10.9976 2.83772 11.9497 3.19133 12.8204C3.25901 12.9871 3.29284 13.0704 3.30794 13.1377C3.32271 13.2036 3.32811 13.2524 3.32812 13.3199C3.32813 13.3889 3.3156 13.4641 3.29053 13.6145L2.79638 16.5794C2.74464 16.8898 2.71876 17.0451 2.76691 17.1573C2.80905 17.2556 2.88735 17.3339 2.9856 17.376C3.09786 17.4242 3.2531 17.3983 3.56358 17.3466L6.52849 16.8524C6.67885 16.8273 6.75403 16.8148 6.82305 16.8148C6.89057 16.8148 6.93933 16.8202 7.00521 16.835C7.07256 16.8501 7.15588 16.8839 7.32252 16.9516C8.1932 17.3052 9.14532 17.5 10.1429 17.5Z",
    stroke: "#0054B6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesSelected);
export default __webpack_public_path__ + "static/media/MessagesSelected.e449d4e3bc05954655909c2e2adac396.svg";
export { ForwardRef as ReactComponent };